module.exports = __webpack_public_path__ + "img/ozon.49bb9eb6.png";